import { Box, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import analysisStyles from "../../Analysis.styles";

interface CustomProps {
  flipCardData: any;
}

const HousesFlipCards = (props: CustomProps) => {
  const classes = analysisStyles;
  const { t } = useTranslation();

  return (
    <Grid item xl={4} lg={6} md={12} sm={12} xs={12} height={"100%"} p={1}>
      <Stack
        direction={"row"}
        sx={classes.planetCardStyle}
        spacing={{ xl: 3, lg: 3, md: 2, sm: 2, xs: 1 }}
      >
        <Stack direction={"column"} spacing={1} sx={{ width: "100%" }}>
          <Stack direction={"row"} sx={classes.planetNameBox}>
            <Typography sx={classes.valueTypo}>
              {props.flipCardData.house}
            </Typography>
          </Stack>
          <Stack direction={"column"} spacing={1} px={2} pb={1}>
            <Box sx={classes.labelTypo} display="inline-block">
              {t("sign")}:
              <Typography
                display="inline-block"
                sx={classes.valueTypo}
                pl={0.5}
              >
                {props.flipCardData.signName || "-"}
              </Typography>
            </Box>
            <Box sx={classes.labelTypo} display="inline-block">
              {t("ruler")}:
              <Typography
                display="inline-block"
                sx={classes.valueTypo}
                pl={0.5}
              >
                {props.flipCardData.ruler || "-"}
              </Typography>
            </Box>
            <Box sx={classes.labelTypo} display="inline-block">
              {t("rulerNakshatra")}:
              <Typography
                display="inline-block"
                sx={classes.valueTypo}
                pl={0.5}
              >
                {props.flipCardData.rulerHouse || "-"}
              </Typography>
            </Box>
            <Box sx={classes.labelTypo} display="inline-block">
              {t("planetHouse")}:
              <Typography
                display="inline-block"
                sx={classes.valueTypo}
                pl={0.5}
              >
                {props.flipCardData.planet || "-"}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Grid>
  );
};

export default HousesFlipCards;
